import Vue, { CreateElement, PropType, VNode } from 'vue';
import { UploadFile } from './Upload';

export default Vue.extend({
  name: 'AheduUploadFileList',
  props: {
    files: Array as PropType<UploadFile[]>,
  },
  methods: {
    onDelete(f: UploadFile) {
      this.$emit('delete', f.uid);
    },
    renderFile(h: CreateElement, file: UploadFile, index: number): VNode {
      return h('div', `${index}-${file.name}`);
    },
  },
  render(h: CreateElement): VNode {
    return h(
      'ul',
      {
        class: 'file-list',
      },
      this.files.map((file, index) => {
        return h(
          'li',
          {
            class: 'file-list-item',
          },
          [this.renderFile(h, file, index)]
        );
      })
    );
  },
});
